import { InboundIframeMessage } from '@utils/iframeMessageBus/types';
import { useIframeMessageBus } from '@utils/iframeMessageBus/useIframeMessageBus';
import { useCallback } from 'react';

type UseIframeMessagesArgs = Readonly<{
  switchToEvent: (id: string) => void;
}>;

export const useIframeMessages = (args: UseIframeMessagesArgs) => {
  const { switchToEvent } = args;
  const handleOnMessage = useCallback(
    (msg: InboundIframeMessage) => {
      if (msg.action === 'eventPickerSelection') {
        switchToEvent(msg.value.id);
      }
    },
    [switchToEvent]
  );

  useIframeMessageBus({ onMessage: handleOnMessage });
};
